import type { UserAvatarUser } from "@/components/ui/user-avatar";
import type { useLanguage } from "@/lib/i18n/LanguageContext";

export type HistoryRelativeTimeCopy = ReturnType<
  typeof useLanguage
>["t"]["documents"]["log"]["history"];

/** Structural subtype shared by BuildingDataHistoryEntry and AttributeHistoryEntry. */
export interface HistoryActorEntry {
  editedBy: number | null;
  editedByName: string | null;
  editedByAvatarUrl: string | null;
  editedByColor: string | null;
  createdAt: string;
}

export function historyActorName(entry: HistoryActorEntry, unknownUser: string): string {
  return entry.editedByName?.trim() || unknownUser;
}

function nullableNamePart(value: string): string | null {
  return value || null;
}

function actorId(value: number | null): number {
  return value ?? 0;
}

export function historyActor(entry: HistoryActorEntry, unknownUser: string): UserAvatarUser {
  const name = historyActorName(entry, unknownUser);
  const [firstName, ...lastName] = name.split(/\s+/);
  return {
    id: actorId(entry.editedBy),
    first_name: nullableNamePart(firstName),
    last_name: nullableNamePart(lastName.join(" ")),
    email: name,
    avatar_url: entry.editedByAvatarUrl,
    color: entry.editedByColor,
  };
}
